import { BREAKPOINTS } from "./constants";

class WindowUtil {
   static getInstance() {
      if (!WindowUtil.instance) {
         WindowUtil.instance = new WindowUtil();
      }
      return WindowUtil.instance;
   }

   constructor() {
      if (WindowUtil.instance) {
         return WindowUtil.instance;
      }

      this.maxEmXsmall = this.convertPxToEm(BREAKPOINTS.sm.px - 1);
      this.maxEmSmall = this.convertPxToEm(BREAKPOINTS.md.px - 1);
      this.maxEmMedium = this.convertPxToEm(BREAKPOINTS.lg.px - 1);
      this.maxEmLarge = this.convertPxToEm(BREAKPOINTS.xl.px - 1);

      this.matchMediaQueryXsmall = window.matchMedia(`(min-width: 1px) and (max-width: ${this.maxEmXsmall}em)`);
      this.matchMediaQuerySmall = window.matchMedia(`(min-width: ${BREAKPOINTS.sm.em}em) and (max-width: ${this.maxEmSmall}em)`);
      this.matchMediaQueryMedium = window.matchMedia(`(min-width: ${BREAKPOINTS.md.em}em) and (max-width: ${this.maxEmMedium}em)`);
      this.matchMediaQueryLarge = window.matchMedia(`(min-width: ${BREAKPOINTS.lg.em}em) and (max-width: ${this.maxEmLarge}em)`);
      this.matchMediaQueryXlarge = window.matchMedia(`(min-width: ${BREAKPOINTS.xl.em}em)`);

      WindowUtil.instance = this;
   }

   convertPxToEm(pxValue) {
      return (pxValue / 16).toFixed(2); // 小数点2桁で丸める
   }
}

export default WindowUtil;
